import firebase from "firebase";
import "firebase/storage";

var firebaseConfig = {
  apiKey: "AIzaSyDML9T7oPT7SX2HavV6BFL0mTMliuxQRvc",
  authDomain: "grospick-mobile.firebaseapp.com",
  projectId: "grospick-mobile",
  storageBucket: "grospick-mobile.appspot.com",
  messagingSenderId: "458393852172",
  appId: "1:458393852172:web:915bfee28503b99b29d129",
  measurementId: "G-WXG3LMX2HJ"
};


firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();

export { storage, firebase as default };